<template>
  <div class="tpl-editor">
    <input
      name="file"
      id="wordFile"
      type="file"
      @change="chooseFile"
      style="display: none"
    />
    <textarea ref="editor"></textarea>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";

export default {
  data() {
    return {
      editor: null
    };
  },
  props: {
    config: {
      default: () => {
        return {
          language: "zh-cn",
          // extraAllowedContent: 'input[*];input{*}',
          allowedContent: true, //放开限制
          ignoreEmptyParagraph: false,
          height: "",
          width: "",
          uiColor: "#E9E9E9",
          toolbar: [
            { name: "clipboard", items: ["Undo", "Redo"] },
            { name: "styles", items: ["Format", "Font", "FontSize"] },
            {
              name: "basicstyles",
              items: [
                "Bold",
                "Italic",
                "Underline",
                "Strike",
                "Subscript",
                "Superscript"
              ]
            },
            { name: "colors", items: ["TextColor", "BGColor"] },
            {
              name: "align",
              items: [
                "JustifyLeft",
                "JustifyCenter",
                "JustifyRight",
                "JustifyBlock"
              ]
            },
            {
              name: "paragraph",
              items: [
                "NumberedList",
                "BulletedList",
                "-",
                "Outdent",
                "Indent",
                "-",
                "Blockquote"
              ]
            },
            { name: "insert", items: ["Image", "Table", "HorizontalRule"] },
            { name: "wordimport", items: ["wordimport"] },
            { name: "tools", items: ["Maximize"] },
            { name: "document", items: ["Source"] }
          ],
          contentsCss: ["/ckeditor/contents.css", "/ckeditor/tpl_editor.css"],
          stylesSet: [
            /* Inline Styles */
            {
              name: "Marker",
              element: "span",
              attributes: { class: "marker" }
            },
            { name: "Cited Work", element: "cite" },
            { name: "Inline Quotation", element: "q" },
            /* Object Styles */
            {
              name: "Special Container",
              element: "div",
              styles: {
                padding: "5px 10px",
                background: "#eee",
                border: "1px solid #ccc"
              }
            },
            {
              name: "Compact table",
              element: "table",
              attributes: {
                cellpadding: "5",
                cellspacing: "0",
                border: "1",
                bordercolor: "#ccc"
              },
              styles: {
                "border-collapse": "collapse"
              }
            },
            {
              name: "Borderless Table",
              element: "table",
              styles: {
                "border-style": "hidden",
                "background-color": "#E6E6FA"
              }
            },
            {
              name: "Square Bulleted List",
              element: "ul",
              styles: { "list-style-type": "square" }
            }
          ],
          bodyClass: "document-editor",
          extraPlugins: "placeholder,notification,wordimport",
          toolbarCanCollapse: true,
          toolbarStartupExpanded: true
        };
      },
      required: false,
      type: Object
    },
    width: {
      default: "100%",
      required: false,
      type: String
    },
    height: {
      default: "600px",
      required: false,
      type: String
    },
    readonly: {
      default: false,
      required: false,
      type: Boolean
    },
    insertHtml: {
      default: "",
      required: false,
      type: String
    },
    changePlaceholder: {
      default: () => {
        return { name: "", oldName: "" };
      },
      required: false,
      type: Object
    },
    delPlaceholder: {
      default: "",
      required: false,
      type: String
    },
    selectPlaceholder: {
      default: "",
      required: false,
      type: String
    },
    value: {
      default: "",
      required: false,
      type: String
    }
  },
  methods: {
    chooseFile: function(e) {
      let file = e.target.files[0];
      let fileTypeStr = "";
      try {
        let fileArr = file.name.split(".");
        fileTypeStr = fileArr[fileArr.length - 1];
      } catch (e) {
        console.log(e);
      }
      let docList = ["doc", "docx"];
      let fixResult = docList.some(function(item) {
        return item === fileTypeStr;
      });

      if (!fixResult) {
        this.$message.error("请上传doc、docx类型的文件");
        return (e.target.value = "");
      }

      let frm = new FormData();
      frm.append("file", file);
      ApiMethods.FileOperController.docToHtml(frm)
        .then(result => {
          if (result.success) {
            let str = result.data.replace(/style="width:595.0pt;margin-bottom:72.0pt;margin-top:72.0pt;margin-left:90.0pt;margin-right:90.0pt;"/g, '')
            this.editor.insertHtml(str);
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => (e.target.value = ""));
    },
    selectAllVar: function(callback) {
      var _this = this;
      var val = this.editor.getData();
      this.editor.setData(val, function() {
        var vars = new Set();
        var widgets = _this.editor.widgets.instances;
        for (var key in widgets) {
          if (
            widgets[key].element.isVisible() &&
            widgets[key].name === "placeholder"
          ) {
            vars.add(widgets[key].data.name);
          }
        }
        callback(vars);
      });
    },
    setData: function(val) {
      this.editor.setData(val);
    },
    render: function() {
      if (this.editor === null) {
        if (this.height) {
          this.config.height = this.height;
        }

        if (this.width) {
          this.config.width = this.width;
        }

        this.editor = CKEDITOR.replace(this.$refs.editor, this.config);

        this.editor.config.readonly = this.readonly;

        this.editor.on("change", this.updata); // editor内容变化时将内容输出到v-module
        this.editor.on("doubleclick", this.handleDoubleclick);
        // editor 加载完成后执行
        this.editor.on("instanceReady", () => {
          this.editor.document.on("click", this.handleClick);
          this.$emit("editorReadyCallback");
        });
      }
    },
    // 单击占位符时输出占位符名称给父组件点击空白则输出空字符串
    handleClick: function(el) {
      el = el.data.getTarget();
      if (el.hasClass("cke_placeholder")) {
        let varHtml = el.getHtml();
        let varName = varHtml.replace(/\[|\]/g, "");
        this.placeholderAddStyle(varName);
        this.$emit("clickPlaceholder", varName);
      } else {
        this.placeholderAddStyle();
        this.$emit("clickPlaceholder", "");
      }
    },
    // 占位符双击时,输出占位符名称给父组件
    handleDoubleclick: function(el) {
      el = el.data.element;
      if (el.hasClass("cke_placeholder")) {
        let varHtml = el.getHtml();
        let varName = varHtml.replace(/\[|\]/g, "");
        this.$emit("doubleclickPlaceholder", varName);
      }
    },
    // 更新数据
    updata: function() {
      let value = this.editor.getData();

      if (this.value !== value) {
        this.$emit("change", value);
      }
    },
    // 占位符高亮
    placeholderAddStyle: function(val) {
      let widgets = this.editor.widgets.instances;
      for (let key in widgets) {
        let widget = widgets[key];
        let Obj = widget.element;

        if (val) {
          if (widget.name === "placeholder" && widget.data.name === val) {
            Obj.setStyle("background", "#fce41c");
          } else {
            Obj.setStyle("background", "");
          }
        } else {
          Obj.setStyle("background", "");
        }
      }
    }
  },
  mounted() {
    this.render();
  },
  computed: {
    computedEditor() {
      return this.editor;
    },
    widgetsInstance() {
      return this.computedEditor.instances;
    }
  },
  watch: {
    insertHtml(val) {
      if (this.editor) {
        if (val && val != "") {
          this.editor.insertHtml(val);
          this.updata();
        }
      }
    },
    // 只读切换
    readonly() {
      if (this.editor) {
        this.editor.readonly = this.readonly;
      }
    },
    delPlaceholder: function(val) {
      // 删除占位符
      let widgets = this.editor.widgets.instances;
      for (let key in widgets) {
        let widget = widgets[key];
        if (widget.name === "placeholder") {
          if (val === widget.data.name) {
            widget.element.remove();
            this.editor.widgets.del(widget);
            this.updata();
          }
        }
      }
    },
    // 输入占位符名称，显示高亮选中状态
    selectPlaceholder: function(val) {
      this.$nextTick(() => {
        this.placeholderAddStyle(val);
      });
    },
    // 修改占位符内容
    changePlaceholder: {
      handler(val) {
        if (this.editor.widgets) {
          let widgets = this.editor.widgets.instances;
          // let widgets = this.widgetsInstance
          for (let key in widgets) {
            let widget = widgets[key];
            if (
              widget.name === "placeholder" &&
              widget.data.name === val.oldName
            ) {
              widget.setData("name", val.name);
            }
          }
        }
      },
      deep: true
    }
  },
  name: "tpl-editor"
};
</script>

<style lang="less" scoped>
.tpl-editor {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// components/tpl-editor/index.vue